import { Component, forwardRef, inject, OnDestroy, OnInit, output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { SpinnerComponent } from '../spinner/spinner.component';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export interface ConfirmDrawEvent {
  params: any;
  type: string | 'confirmDraw';
}

@Component({
  selector: 'app-exposed-map',
  standalone: true,
  imports: [
    SpinnerComponent
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ExposedMapComponent),
      multi: true
    }
  ],
  templateUrl: './exposed-map.component.html'
})
export class ExposedMapComponent implements OnInit, ControlValueAccessor, OnDestroy {

  public disabled: boolean = false;

  public value: string | null = null;

  public onChange: any = () => {
  };

  public onTouch: any = () => {
  };

  public writeValue(value: string | null): void {
    this.value = value;
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public close = output<string | null>();

  private httpClient: HttpClient = inject(HttpClient);

  public loading = true;
  public displayContent = false;

  onConfirmDraw: (e: MessageEvent) => void = (e: MessageEvent) => {
    if (e.data?.type === 'confirmDraw') {
      const value: ConfirmDrawEvent = e.data as ConfirmDrawEvent;
      this.value = JSON.stringify(value);
      this.onChange(this.value);
      this.close.emit(this.value);
    }
  };

  public ngOnInit(): void {
    this.httpClient.post<{ token: string }>(environment.apiBasePath + '/smartgem/login', {}).subscribe({
      next: (response: { token: string }) => {
        sessionStorage.setItem('x-auth-token', response.token);
        sessionStorage.setItem('x-auth-login', 'euslugi');
      },
      complete: () => {
        this.displayContent = true;
        setTimeout(() => {
          const element: HTMLIFrameElement = document.getElementById('exposed-map') as HTMLIFrameElement;
          element.onload = () => {
            window.addEventListener('message', this.onConfirmDraw);
            this.loading = false;
          };
        });
      },
      error: (err: any) => {
        this.loading = false;
        this.displayContent = true;
      }
    });
  }

  public ngOnDestroy(): void {
    window.removeEventListener('message', this.onConfirmDraw);
  }
}
